import { useMemo } from 'react';
import { DateTime } from 'luxon';
export var ADDITIONAL_DAYS = 7;
export var useFindShiftsPageAsyncQueryParams = function (selectedDate) {
    var times = [];
    var startOfDayAfterSelectedDate = useMemo(function () { return selectedDate.plus({ days: 1 }).startOf('day').toUTC().toISO(); }, [selectedDate]);
    var endOfTodayPlusAdditionalDays = useMemo(function () {
        return DateTime.now()
            .plus({ days: ADDITIONAL_DAYS })
            .endOf('day')
            .toUTC()
            .toISO();
    }, []);
    var startOfTodayOrSelectedDayMinusAdditionalDays = useMemo(function () {
        return DateTime.max(DateTime.now().startOf('day'), selectedDate.minus({ days: ADDITIONAL_DAYS }).startOf('day'))
            .toUTC()
            .toISO();
    }, [selectedDate]);
    var endOfDayBeforeSelectedDay = useMemo(function () { return selectedDate.minus({ days: 1 }).endOf('day').toUTC().toISO(); }, [selectedDate]);
    if (selectedDate.diffNow('days').days < 6.9) {
        times.push({
            startTime: startOfDayAfterSelectedDate,
            endTime: endOfTodayPlusAdditionalDays
        });
    }
    if (selectedDate.diffNow('days').days > 0) {
        times.push({
            startTime: startOfTodayOrSelectedDayMinusAdditionalDays,
            endTime: endOfDayBeforeSelectedDay
        });
    }
    return times;
};
